import type { NodeInstance } from '@glueapp/graph-types';
import { UnpackLayout } from '@/GraphEditor/drawingLayer/nodeComposition/UnpackLayout';

interface Props {
    nodeInstance: NodeInstance;
}

export const UnpackNode: React.FC<Props> = ({ nodeInstance }) => {
    return <UnpackLayout nodeInstance={nodeInstance} />;
};
